import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsDialogModule } from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';

import { UserProfileService } from './core/user-profile.service';
import { TooltipComponent } from './tooltip/tooltip.component';
import { TranslationIdMap } from './tooltip/tooltip.component.i18n';

@NgModule({
    declarations: [TooltipComponent],
    exports: [TooltipComponent],
    imports: [
        CmpsDialogModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsCommonModule,
        CommonModule,
    ],
    providers: [UserProfileService],
})
export class CmpsUserProfileModule {}
